import React from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleUser } from '@fortawesome/free-regular-svg-icons';
import { faWallet, faHouse, faBook, faClockRotateLeft } from '@fortawesome/free-solid-svg-icons';
import './Footer.css';
import { useT } from '../i18n';

const navClass = ({ isActive }) => `ftr-item${isActive ? ' active' : ''}`;

const Footer = () => {
  const { pathname } = useLocation();
  const { t } = useT();
  const isHome = pathname === '/' || pathname === '/home';

  return (
    <footer className="sticky-footer app-footer">
      <nav className="footer-content">
        <NavLink to="/profile" className={navClass}>
          <FontAwesomeIcon icon={faCircleUser} />
          <span>{t('Account')}</span>
        </NavLink>
        <NavLink to="/wallet_histroy" className={navClass}>
          <FontAwesomeIcon icon={faWallet} />
          <span>{t('Wallet')}</span>
        </NavLink>
        <Link to="/home" className={`ftr-home${isHome ? ' active' : ''}`} aria-label={t('Home')}>
          <FontAwesomeIcon icon={faHouse} />
        </Link>
        <NavLink to="/account-statement" className={navClass}>
          <FontAwesomeIcon icon={faBook} />
          <span>{t('History')}</span>
        </NavLink>
        <NavLink to="/all-bid" className={navClass}>
          <FontAwesomeIcon icon={faClockRotateLeft} />
          <span>{t('All Bids')}</span>
        </NavLink>
      </nav>
    </footer>
  );
};

export default Footer;
